import { Stack, Typography, useTheme } from '@mui/material';

import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { pxToRem } from '@/theme/typography';

export const CheckoutCvvInputInfo: FC = () => {
  const theme = useTheme();

  return (
    <Stack
      direction='row'
      spacing='8px'
      sx={{
        alignItems: 'center',
        marginTop: {
          mobile: '7px',
          tablet: pxToRem(4),
        },
      }}
    >
      <InfoOutlinedIcon
        sx={{
          color: theme.palette.typography.color.muted,
          width: '16px',
          height: '16px',
        }}
      />
      <Typography
        component='span'
        sx={{
          textAlign: 'left',
          fontSize: '13px',
          color: theme.palette.typography.color.muted,
        }}
      >
        <FormattedMessage id='my_credit_cards.supported_cvvs' />
      </Typography>
    </Stack>
  );
};
